export const reorderObjectKeyValues = (obj: any, order: string[]) => {
  const newObject = {};
  if (obj && order && order.length) {
    order.forEach((value, key) => {
      if (obj.hasOwnProperty(order[key])) {
        newObject[order[key]] = obj[order[key]];
      }
    })
    return newObject;
  }
  return obj;
}

export const revObjectOrder = (obj: any) => {
  const newObj = {}
  const revObj = Object.keys(obj).reverse();
  revObj.forEach((i) => {
    newObj[i] = obj[i];
  })
  return newObj;
}

/**
 * Takes a value and removes all "isEmpty" elements, including the value itself if it's an empty object or array.
 * For arrays, it keeps the array length if there are "not isEmpty" values.
 * @param value object, array or any
 * @param isEmpty
 */
export const removeEmpty = (value: any, isEmpty = v => v === null || v === undefined): any | undefined => {
  if (isEmpty(value)) return undefined;
  if (typeof value === 'object') {
    const val = Object.entries(value)
      .reduce((acc, [k, v]) => {
        const val = removeEmpty(v);
        if (!isEmpty(val)) acc[k] = val;
        return acc;
      }, {});
    return Object.values(val).filter(x => !isEmpty(x)).length ? val : undefined;
  }
  if (Array.isArray(value)) {
    const val = value.map(x => removeEmpty(value));
    return val.filter(x => !isEmpty(x)).length ? val : undefined;
  }
  return value;
}
